import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-components/base-component.component';
import { Subject } from 'rxjs';
@Component({
    selector: 'app-view',
    template: `
        <div class="d-flex flex-row gap-1">
            <button
                *ngIf="isShowViewButton" 
                    class="d-flex gap-2 align-items-center action-button"
                    (click)="onViewItem()">
                <img class="icon" src="assets/icon/search.png">
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        `
    ]
})
export class ViewComponent extends BaseComponent {
    public isShowViewButton: boolean = true;

    @Output()
    emitter = new Subject<{ action: string, data: any }>();

    @Input()
    data: any = {};
    onViewItem() {
        this.emitter.next({
            action: 'view',
            data: this.data,
        });
    }
}
